import { z } from "zod";
import { weightUnits } from "../../units";
import { ZodNumberPositiveNullable } from "../zod-types/zod-number-nullable";

export const weightFormSchema = z
	.object({
		weight: ZodNumberPositiveNullable,
		weightUnit: z
			.preprocess((val) => {
				if (!val) return null;
				return val;
			}, z.enum(weightUnits).default("kilogram").nullable())
			.nullish(),
	})
	.superRefine((values, context) => {
		if (values.weight) {
			if (!values.weightUnit) {
				context.addIssue({
					code: "custom",
					message: "Weight unit is required",
					path: ["sizeUnit"],
				});
			}
		}
	})
	.transform((values) => {
		if (!values.weight) {
			values.weightUnit = null;
		}
		return values;
	});

export type WeightFormSchema = z.infer<typeof weightFormSchema>;
export const weightNumberFields = ["weight"] as const;
export const weightUnitField = "weightUnit" as const;
export type WeightNumberField = (typeof weightNumberFields)[number];
export type WeightUnitField = typeof weightUnitField;
